module.exports = ".tabbar {\r\n    border-top: 1px solid #ccc !important;\r\n}\r\n\r\nons-tab.not-used {\r\n    z-index: -1;\r\n    display: none;\r\n}\r\n\r\n:host ::ng-deep ons-modal {\r\n    opacity: 0.75;\r\n}\r\n\r\n:host ::ng-deep .modal__content {\r\n    color: black;\r\n}\r\n\r\n* {\r\n    -webkit-overflow-scrolling: auto;\r\n}\r\n\r\n.frame-css-mobile {\r\n    width: 100%;\r\n    height: 100%;\r\n    position: fixed;\r\n}\r\n\r\n.fixed-tab {\r\n    position: fixed;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/client-app/client-app.component.css
// module id = ./src/app/client-app/client-app.component.css
// module chunks = main